import React from 'react';
import PropTypes from 'prop-types';
import { Context } from '../../Context';
import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography, TextField, Grid, Checkbox, FormControlLabel, FormGroup, FormControl, FormLabel, Button, CircularProgress } from '@material-ui/core/';
import { Countries } from '../../Config/countries';
import ProfileStyles from '../../Styles/ProfileStyles';
import { Mixpanel } from '../../Config/mixpanel';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@material-ui/core/Link';

const errorMessages = {
	'companyNameError': 'Please enter the company name',
	'firstNameError': 'Please enter your first name',
	'lastNameError': 'Please enter your last name',
	'instagramError': 'Please enter your Instagram account',
	'countryError': 'Please select your country',
	'emailError': 'Please enter a valid email address',
	'phoneError': 'Please enter a valid phone number',
	'addressLine1Error': 'Please enter the first line of the address',
	'postcodeError': 'Please enter a valid postcode'
}

class Profile extends React.Component {
	constructor() {
		super();
		this.state = this.getInitialState();

		this.handleSave = this.handleSave.bind(this);
		this.handleAcceptTandC = this.handleAcceptTandC.bind(this);
		this.handleAcceptMarketing = this.handleAcceptMarketing.bind(this);
	}

	getInitialState = () => {
		const initialState = {
			companyNameError: false,
			firstNameError: false,
			lastNameError: false,
			instagramError: false,
			countryError: false,
			emailError: false,
			phoneError: false,
			addressLine1Error: false,
			postcodeError: false,
			acceptTandC: false,
			acceptMarketing: false,
			errorState: false,
			paymentMethod: 'card',
			stripe: null
		};
		return initialState;
	}

	componentDidMount() {
		Mixpanel.track('Viewed page profile');
		if (!this.context.state.user) {
			this.context.actions.getUserProfile();
		}
	}

	handleChange = name => event => {
		if (event.target.type !== 'checkbox') {
			this.context.actions.updateUserProfile({
				[name]: event.target.value,
			});
		}
	};

	handleAddressChange = name => event => {
		this.context.actions.updateUserProfile({
			address: {
				...this.context.state.user.address,
				[name]: event.target.value
			}
		});
	}

	handleAcceptTandC() {
		this.setState({
			acceptTandC: !this.state.acceptTandC
		});
	}

	handleAcceptMarketing() {
		this.setState({
			acceptMarketing: !this.state.acceptMarketing
		});
	}

	handleSave() {
		this.setState(this.getInitialState(), () => {

			Mixpanel.track('Save attempt advertiser profile');

			const { user } = this.context.state;
			let errorState = false;

			if (!user.companyName || user.companyName.length > 100 || user.companyName.length < 1) {
				errorState = true;
				this.setState({
					companyNameError: true
				});
			}
			if (!user.address || !user.address.addressLine1 || user.address.addressLine1.length > 100 || user.address.addressLine1.length < 1) {
				errorState = true;
				this.setState({
					addressLine1Error: true
				});
			}
			if (!user.address || !user.address.postcode || user.address.postcode.length > 30 || user.address.postcode.length < 1) {
				errorState = true;
				this.setState({
					postcodeError: true
				});
			}
			if (!user.address || !user.address.country) {
				errorState = true;
				this.setState({
					countryError: true
				});
			}
			if (!user.firstName || user.firstName.length > 1000 || user.firstName.length < 3) {
				errorState = true;
				this.setState({
					firstNameError: true
				});
			}
			if (!user.lastName || user.lastName.length > 1000 || user.lastName.length < 3) {
				errorState = true;
				this.setState({
					lastNameError: true
				});
			}
			if (!user.email || !this.validateEmail(user.email)) {
				errorState = true;
				this.setState({
					emailError: true
				});
			}
			if (!user.phone) {
				errorState = true;
				this.setState({
					phoneError: true
				});
			}
			if (!user.instagram || user.instagram.length > 1000 || user.instagram.length < 1) {
				errorState = true;
				this.setState({
					instagramError: true
				});
			}
			if (errorState) {
				this.setState({ errorState: true }, () => {
					Mixpanel.track('Error saving user profile', { error: this.state, user: this.context.state.user });
				});
			}
			else {
				Mixpanel.track('Saved advertiser profile', { user: this.context.state.user });
				if (this.context.state.user.status === 'created') {
					Mixpanel.track('Onboarding advertiser complete');
				}
				this.context.actions.saveUserProfile();
			}
		});
	}

	validateEmail(email) {
		var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	}

	render() {
		const { classes } = this.props;
		const { user } = this.context.state;

		return (
			<div className={classes.main}>
				{(this.context.state.loading || !user)
					? (<CircularProgress size={24} className={classes.progress} />)
					:
					<Paper className={classes.paper}>
						<form noValidate autoComplete="off" onSubmit={this.handleSubmit}>
							<Grid container spacing={3}>
								<Grid item xs={12}>
									<Typography variant="h4">
										Account details
									</Typography>
									<Typography variant="subtitle1">
										Filling in your account details helps Vimma optimise campaigns for you
									</Typography>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="h6" className={classes.typography}>
										Company
									</Typography>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="subtitle1" className={classes.typography}>
										Company details
									</Typography>
								</Grid>
								<Grid item xs={12}>
									<TextField
										label="Company Name"
										className={classes.textField}
										value={user.companyName}
										onChange={this.handleChange('companyName')}
										fullWidth
										autoFocus
										margin="normal"
										variant="outlined"
										required={true}
										error={this.state.companyNameError}
										helperText={this.state.companyNameError ? errorMessages.companyNameError : ''}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										label="Company Number"
										className={classes.textField}
										value={user.companyNumber}
										onChange={this.handleChange('companyNumber')}
										fullWidth
										margin="normal"
										variant="outlined"
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										label="VAT number/Tax code"
										className={classes.textField}
										value={user.companyVatNumber}
										onChange={this.handleChange('companyVatNumber')}
										fullWidth
										margin="normal"
										variant="outlined"
									/>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="subtitle1" className={classes.typography}>
										Address
									</Typography>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										label="Address line 1"
										className={classes.textField}
										value={user.address ? user.address.addressLine1 : ''}
										onChange={this.handleAddressChange('addressLine1')}
										fullWidth
										required={true}
										margin="normal"
										variant="outlined"
										error={this.state.addressLine1Error}
										helperText={this.state.addressLine1Error ? errorMessages.addressLine1Error : ''}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										label="Address line 2"
										className={classes.textField}
										value={user.address ? user.address.addressLine2 : ''}
										onChange={this.handleAddressChange('addressLine2')}
										fullWidth
										margin="normal"
										variant="outlined"
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										label="Address line 3"
										className={classes.textField}
										value={user.address ? user.address.addressLine3 : ''}
										onChange={this.handleAddressChange('addressLine3')}
										fullWidth
										margin="normal"
										variant="outlined"
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										label="Postcode"
										className={classes.textField}
										value={user.address ? user.address.postcode : ''}
										onChange={this.handleAddressChange('postcode')}
										fullWidth
										required={true}
										margin="normal"
										variant="outlined"
										error={this.state.postcodeError}
										helperText={this.state.postcodeError ? errorMessages.postcodeError : ''}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										select
										fullWidth
										label="Country"
										className={classes.textField}
										value={user.address ? user.address.country : ''}
										onChange={this.handleAddressChange('country')}
										SelectProps={{
											native: true
										}}
										margin="normal"
										variant="outlined"
										required={true}
										error={this.state.countryError}
										helperText={this.state.countryError ? errorMessages.countryError : ''}>
										{Countries.map(option => (
											<option key={option} value={option}>
												{option}
											</option>
										))}
									</TextField>
								</Grid>
								<Grid item xs={12} sm={3}>
									<TextField
										label="City/Town"
										className={classes.textField}
										value={user.address ? user.address.city : ''}
										onChange={this.handleAddressChange('city')}
										fullWidth
										margin="normal"
										variant="outlined"
									/>
								</Grid>
								<Grid item xs={12} sm={3}>
									<TextField
										label="State"
										className={classes.textField}
										value={user.address ? user.address.state : ''}
										onChange={this.handleAddressChange('state')}
										fullWidth
										margin="normal"
										variant="outlined"
									/>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="h6" className={classes.typography}>
										Contact Person
									</Typography>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										label="First Name"
										className={classes.textField}
										value={user.firstName}
										onChange={this.handleChange('firstName')}
										fullWidth
										margin="normal"
										variant="outlined"
										required={true}
										error={this.state.firstNameError}
										helperText={this.state.firstNameError ? errorMessages.firstNameError : ''}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										label="Last Name"
										className={classes.textField}
										value={user.lastName}
										onChange={this.handleChange('lastName')}
										fullWidth
										margin="normal"
										variant="outlined"
										required={true}
										error={this.state.lastNameError}
										helperText={this.state.lastNameError ? errorMessages.lastNameError : ''}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										label="Email"
										className={classes.textField}
										type="email"
										name="email"
										fullWidth
										value={user.email}
										onChange={this.handleChange('email')}
										margin="normal"
										variant="outlined"
										required={true}
										error={this.state.emailError}
										helperText={this.state.emailError ? errorMessages.emailError : ''}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										label="Phone number"
										fullWidth
										value={user.phone}
										onChange={this.handleChange('phone')}
										className={classes.textField}
										margin="normal"
										variant="outlined"
										required={true}
										error={this.state.phoneError}
										helperText={this.state.phoneError ? errorMessages.phoneError : 'Please include the country code'}
									/>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="h6" className={classes.typography}>
										Social Media
									</Typography>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="subtitle1" className={classes.typography}>
										Which social media platforms are you using?
									</Typography>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										label="Instagram"
										className={classes.textField}
										value={user.instagram}
										onChange={this.handleChange('instagram')}
										fullWidth
										margin="normal"
										variant="outlined"
										required={true}
										error={this.state.instagramError}
										helperText={this.state.instagramError ? errorMessages.instagramError : 'Instagram handle'}
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										label="Facebook"
										className={classes.textField}
										value={user.facebook}
										onChange={this.handleChange('facebook')}
										fullWidth
										margin="normal"
										variant="outlined"
										helperText='Facebook username'
									/>
								</Grid>
								<Grid item xs={12} sm={6}>
									<TextField
										label="Twitter"
										className={classes.textField}
										value={user.twitter}
										onChange={this.handleChange('twitter')}
										fullWidth
										margin="normal"
										variant="outlined"
										helperText='Twitter handle'
									/>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="h6" className={classes.typography}>
										Payment Methods
									</Typography>
								</Grid>
								<Grid item xs={12}>
									<Typography variant="subtitle1" className={classes.typography}>
										With Vimma, you can save pay either by card or via bank transfer.
									</Typography>
								</Grid>
								<Grid item xs={12} style={{ textAlign: 'center' }}>
									<Link component={RouterLink} to={user.status === 'created' ? '/payment-methods' : '/account/payment-methods'} variant="body1">
										Manage payment methods
									</Link>
									{/* <Link to={`/account/paymentMethods`}>Manage payment methods</Link> */}
									{/* <FormControl component="fieldset">
										<RadioGroup
											aria-label="caption"
											name="caption"
											value={this.state.paymentMethod}
											onChange={this.handlePaymentDetailsChange}
										>
											<FormControlLabel value="card" control={<Radio color='primary' />} label="Pay with card" />
											<FormControlLabel value="invoice" control={<Radio color='primary' />} label="Pay by bank transfer" />
										</RadioGroup>
									</FormControl>
									{this.state.paymentMethod === 'card' && (
										
									)} */}
								</Grid>
								<Grid item xs={12}>
									<a href='https://site.vimma.co/ToS-Marketers' target='_blank' rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
										<Typography variant="h6" className={classes.typography}>
											Terms and Conditions
										</Typography>
									</a>
								</Grid>
								<Grid item xs={12}>
									<div className={classes.textField}>
										<FormControl>
											<FormLabel>Please accept to continue. Terms and conditions can be found <a href='https://vimma.co/ToS-Marketers' target='_blank' rel="noopener noreferrer">here</a>.</FormLabel>
											<FormGroup row={false}>
												<FormControlLabel
													control={
														<Checkbox
															checked={this.state.acceptTandC}
															onChange={this.handleAcceptTandC}
															color="primary"
														/>
													}
													label="I agree to the terms and conditions"
												/>
												<FormControlLabel
													control={
														<Checkbox
															checked={this.state.acceptMarketing}
															onChange={this.handleAcceptMarketing}
															color="primary"
														/>
													}
													label="I agree to be contacted about new products and features"
												/>
											</FormGroup>
										</FormControl>
									</div>
								</Grid>
								{this.state.errorState && (
									<Grid item xs={12}>
										<Typography variant="subtitle1" color='primary'>
											Please fill in all the required fields and try again
										</Typography>
									</Grid>
								)}
								<Grid item xs={12} >
									<Grid container justify="space-between">
										<Grid item>
											<Button onClick={this.handleSave} disabled={!(this.state.acceptTandC && this.state.acceptMarketing)} variant="contained" size="large" color="primary">
												Save
      										</Button>
										</Grid>
										<Grid item>
											<Button onClick={this.context.actions.logout}>
												Logout
      										</Button>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</form>
					</Paper>}
			</div>
		);
	}
}

Profile.propTypes = {
	classes: PropTypes.object.isRequired,
};

Profile.contextType = Context;

export default withStyles(ProfileStyles)(Profile);
